import { IJSLComponent, IJSLVNode, refresh } from "jsl-render";
import Axios from "axios";

export class UploadExcelComponent implements IJSLComponent {

    private loading = false;
    private result: string;

    public render(): IJSLVNode {
        return <section class="banner-area">
            {this.result ? <div class="ml-20">
                {{ tag: "div", content: this.result, raw: true }}
                <button class="genric-btn default-border" click={() => {
                    location.reload();
                }}>weitere hochladen</button>
            </div> :
                <div class="ml-20">
                    <h3>Fund per Excel melden</h3>
                    <p>
                        Laden Sie die Excel Vorlage herunter und füllen Sie das Blatt "Funde" aus:
                <a href="Home/DownloadTemplate" class="genric-btn default-border">Vorlage generieren</a>
                    </p>
                    <p>
                        Danach laden Sie hier die Datei wieder hoch.
            </p>
                    <p>
                        <input type="file" multiple />
                        <button class="genric-btn primary" style={this.loading ? "visibility:hidden" : ""}
                            click={(evt, node) => { this.upload(node.dom.parentElement.querySelector("input")); }}>
                            hochladen</button>
                        <p>&nbsp;</p>
                    </p>
                </div>}
        </section>;
    }

    private upload(el: HTMLInputElement) {
        const files = el.files;
        if (files.length > 0) {
            const imgformData = new FormData();
            for (let i = 0; i < files.length; i++) {
                imgformData.append("files", files[i]);
            }
            this.loading = true;
            Axios.post("api/public/uploadexcel", imgformData, {}).then((res) => {
                this.result = res.data as string;
                // console.log(this.result);
                // console.log(res);
                refresh();
            }).catch((e) => {
                this.loading = false;
                alert("error: " + e.response.data.title);
                refresh();
            });
        }
    }

}
